import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useGetEnrichmentItems } from '../contact-enrichment-options/hooks/use-get-enrichment-items';

export function useSelectedItems() {
  const { getValues } = useFormContext();
  const checked = getValues();
  const { items } = useGetEnrichmentItems();

  const selectedItems = useMemo(() => {
    const checkedItems = items.filter((item) => checked[item.value]);

    if (checkedItems.length === 0) {
      return null;
    }

    return `${checkedItems.map((item) => item.title).join(', ')}`;
  }, [checked, items]);

  return selectedItems;
}
